import { default as BaseNodePage } from "./index"
export { getServerSideProps } from "./index"

const SlugPage = (props) => <BaseNodePage {...props} />

export default SlugPage
